export const SALARY_RANGES = [
  { value: '< $30,000', primaryText: '< $30,000', integerValue: 29999 },
  { value: '$30,000', primaryText: '$30,000', integerValue: 30000 },
  { value: '$40,000', primaryText: '$40,000', integerValue: 40000 },
  { value: '$50,000', primaryText: '$50,000', integerValue: 50000 },
  { value: '$60,000', primaryText: '$60,000', integerValue: 60000 },
  { value: '$70,000', primaryText: '$70,000', integerValue: 70000 },
  { value: '$80,000', primaryText: '$80,000', integerValue: 80000 },
  { value: '$90,000', primaryText: '$90,000', integerValue: 90000 },
  { value: '$100,000', primaryText: '$100,000', integerValue: 100000 },
  { value: '$110,000', primaryText: '$110,000', integerValue: 110000 },
  { value: '$120,000', primaryText: '$120,000', integerValue: 120000 },
  { value: '$130,000', primaryText: '$130,000', integerValue: 130000 },
  { value: '$140,000', primaryText: '$140,000', integerValue: 140000 },
  { value: '$150,000', primaryText: '$150,000', integerValue: 150000 },
  { value: '$160,000', primaryText: '$160,000', integerValue: 160000 },
  { value: '$170,000', primaryText: '$170,000', integerValue: 170000 },
  { value: '$180,000', primaryText: '$180,000', integerValue: 180000 },
  { value: '$190,000', primaryText: '$190,000', integerValue: 190000 },
  { value: '$200,000', primaryText: '$200,000', integerValue: 200000 },
  { value: '$210,000', primaryText: '$210,000', integerValue: 210000 },
  { value: '$220,000', primaryText: '$220,000', integerValue: 220000 },
  { value: '$230,000', primaryText: '$230,000', integerValue: 230000 },
  { value: '$240,000', primaryText: '$240,000', integerValue: 240000 },
  { value: '$250,000', primaryText: '$250,000', integerValue: 250000 },
  { value: '> $250,000', primaryText: '> $250,000', integerValue: 259999 },
];
